var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevernDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.40479L12.424 16.98C12.3683 17.0357 12.3023 17.0799 12.2295 17.1101C12.1567 17.1402 12.0788 17.1558 12 17.1558C11.9212 17.1558 11.8433 17.1402 11.7705 17.1101C11.6977 17.0799 11.6317 17.0357 11.576 16.98L3 8.40479",
    stroke: "#B6B6B4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevernDown);
export default __webpack_public_path__ + "static/media/chevern-down.6b5ee79acc62707c9eebb91a3b61f327.svg";
export { ForwardRef as ReactComponent };